import type { PremiumFile } from '$types/interfaces';
import { Collections, type PremiumFilesResponse } from '$types/pocketbase';
import type PocketBase from 'pocketbase';
import { getFileURL } from '$lib/pocketbase/helper';

export const getAll = (pb: PocketBase): Promise<PremiumFile[]> =>
  pb
    .collection(Collections.PremiumFiles)
    .getFullList<PremiumFilesResponse>({
      sort: 'order'
    })
    .then((response) =>
      response.map((file) => ({
        id: file.id,
        name: file.name,
        file: getFileURL(file, file.file),
        order: file.order
      }))
    );

export const getLastOrder = (pb: PocketBase): Promise<number> =>
  pb
    .collection(Collections.PremiumFiles)
    .getFirstListItem<PremiumFilesResponse>('', {
      sort: '-order'
    })
    .then(({ order }) => order)
    .catch(() => 0);

export async function create(pb: PocketBase, name: string, file: File) {
  const data = new FormData();
  data.append('name', name);
  data.append('file', file);
  data.append('order', `${(await getLastOrder(pb)) + 1}`);
  return await pb.collection(Collections.PremiumFiles).create<PremiumFilesResponse>(data);
}

export async function update(pb: PocketBase, id: string, name: string, file?: File) {
  const data = new FormData();
  data.append('name', name);
  if (file) {
    data.append('file', file);
  }
  return await pb.collection(Collections.PremiumFiles).update<PremiumFilesResponse>(id, data);
}

export async function remove(pb: PocketBase, id: string) {
  return await pb.collection(Collections.PremiumFiles).delete(id);
}
